export default __webpack_public_path__ + "static/media/cancelIcon.01dfee4b.svg";